import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeProfile } from '../api/userApi';
import { RANK_IMAGES } from '../utils/rankConstants';
import '../Style/completeProfile.css';

function CompleteProfile({ currentUser, setCurrentUser }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    gender: '',
    birthDate: '',
  });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!currentUser) {
      navigate('/login');
    }
  }, [currentUser, navigate]);

  if (!currentUser) return <div className="loading-screen">Loading setup...</div>;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    if (Object.values(formData).some((val) => !val)) {
      setError('Please complete all required fields.');
      setIsSubmitting(false);
      return;
    }

    try {
      console.log('Submitting complete profile...', currentUser.id, formData);

      const updatedUser = await completeProfile(currentUser.id, formData);

      console.log('Complete profile response:', updatedUser);

      setCurrentUser(updatedUser);
      localStorage.setItem('user', JSON.stringify(updatedUser));

      console.log('Navigating to onboarding...');
      navigate('/onboarding', { replace: true });
    } catch (err) {
      console.error('Complete profile failed:', err);
      console.error('Response:', err.response?.data);

      const data = err.response?.data;
      const message =
        typeof data === 'string'
          ? data
          : data?.message || 'Something went wrong. Please try again.';
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="setup-page">
      <div className="setup-card">
        <div className="setup-header">
          <img src={RANK_IMAGES.DIAMOND} alt="Setup" className="setup-icon" />
          <h1>Complete Your Profile</h1>
          <p>Add a few details so we can set up your account.</p>
        </div>

        {error && <div className="setup-error-badge">{error}</div>}

        <form onSubmit={handleSubmit} className="setup-form">
          <div className="input-group">
            <label>Full Name</label>
            <div className="name-inputs">
              <input name="firstName" placeholder="First Name" onChange={handleChange} required />
              <input name="lastName" placeholder="Last Name" onChange={handleChange} required />
            </div>
          </div>

          <div className="input-group">
            <label>Gender Identity</label>
            <select name="gender" onChange={handleChange} required>
              <option value="">Select Option</option>
              <option value="MAN">Man</option>
              <option value="WOMAN">Woman</option>
              <option value="NON_BINARY">Non-binary</option>
              <option value="PREFER_NOT_TO_SAY">Other / Private</option>
            </select>
          </div>

          <div className="input-group">
            <label>Birth Date</label>
            <input type="date" name="birthDate" onChange={handleChange} required />
          </div>

          <button type="submit" className="setup-submit-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : 'Save and Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CompleteProfile;
